import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import Config, { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { FaCheck } from "react-icons/fa6";
import { MdOutlineChevronRight } from "react-icons/md";
import { IoCopySharp } from "react-icons/io5";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../helpers";
import Tooltip from "../Tooltip";
import TenantMiniProfile from "../Common/TenantMiniProfile";

const Table = ({
  apiData,
  setSelectedData,
  userType,
  isMovingOut,
}) => {

  const storageKey = `tenant_active_page`;
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  // Load saved page index
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const ActionBtns = (item) => (
    <Tooltip label="View tenant details">
      <button
        onClick={() => goToDues("Tenant Info", item)}
        className="px-2 ml-auto text-gray-400 hover:text-gray-700 transition"
      >
        <MdOutlineChevronRight size={22} />
      </button>
    </Tooltip>
  );


  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        //getProperty: getProperty(item),
        rent: '₹' + item.rent,
        security: '₹' + (item.security || 0),
        dues: getDues(item),
        roomNum: getPropertyName(item),
        moveInOutDate: isMovingOut === 'M' ? <MoveOutData>{item.moveOutDate}</MoveOutData> : moveInOutDate(item),
        status: combineStatusAndKyc(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    return <TenantMiniProfile
      tenantId={item.tenantId}
      name={item.name}
      mobile={item.mobile}
      profilePicture={item.profilePicture}
      kycStatus={item.kycStatus}
      flatName={`${item.roomNum}, ${item.flatName}, ${item.propertyName}`}
    />
  };


  const getStatus = (status) => {
    if (status === 1) {
      return <Unverified>Unverified</Unverified>;
    } else if (status === 2) {
      return <Vaccines>Vacant</Vaccines>;
    } else if (status === 3) {
      return <Linked>Linked</Linked>;
    } else if (status === 4) {
      return <Requested>Requested</Requested>;
    } else if (status === 5) {
      return <Occupied>Occupied</Occupied>;
    } else if (status === 6) {
      return <Moving>Moving Out</Moving>;
    } else if (status === 7) {
      return <Reserved>Reserved</Reserved>;
    }
  };

  const getKycStatus = (kycStatus) => {
    if (kycStatus === 1) {
      return <KycPending title="KYC Pending">P</KycPending>;
    } else if (kycStatus === 2) {
      return <IdUpload title="KYC ID Uploaded">IU</IdUpload>;
    } else if (kycStatus === 3) {
      return <Personal title="KYC Pinfo Submitted">PS</Personal>;
    } else if (kycStatus === 4) {
      return <Selfie title="KYC Selfie Uploaded">SU</Selfie>;
    } else if (kycStatus === 5) {
      return <RentAgreement title="KYC Rent Agreement">RA</RentAgreement>;
    } else if (kycStatus === 6) {
      return <Verification title="KYC Police Verification">PV</Verification>;
    } else {
      return <Unknown title="KYC Unknown status">US</Unknown>;
    }
  };

  const combineStatusAndKyc = (item) => {
    const statusElement = getStatus(item.status);
    const kycElement = getKycStatus(item.kycStatus);
    return (
      <div className="flex gap-1 cursor-pointer" onClick={() => goToDues('Tenant Info', item)}>
        <span>{statusElement}</span>
        {/* <span>{kycElement}</span> */}
      </div>
    );
  };

  const goToDues = (clickOn, item) => {
    navigate(`/tenantdetails/l/${item.tenantId}`, {
      state: {
        tabName: clickOn,
        tabKey: "totalDues",
      },
    });
  };

  const getDues = (item) => {
    if (Number(item?.totalDues) === 0) {
      return (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          No dues
        </span>
      );
    }

    return <Amount>₹{item?.totalDues}</Amount>;
  };

  // const getDuesOld = (item) => {
  //   return (
  //     <div className="flex items-center gap-2" onClick={() => notes(item)}>
  //       <Tooltip label="Click to view and add notes">
  //         <span className="text-gray-600 text-sm bg-rose-100 px-3 py-1 rounded-md inline-flex cursor-pointer"
  //         >
  //           {"₹" + (item?.totalDues || 0)}
  //         </span>
  //       </Tooltip>

  //     </div>
  //   );
  // };

  const getPropertyName = (item) => {
    return (
      <div className="flex flex-col gap-0.5 cursor-pointer" onClick={() => goToDues('Tenant Info', item)}>
        <span className="text-gray-600 text-sm truncate"
          title={item.propertyName}
        >
          {truncateText(item.propertyName, 28)}
        </span>
      </div>
    );
  };

  const moveInOutDate = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col text-sm text-gray-600">
          <span>
            {item.moveInDate
              ? moment(item.moveInDate).format("DD, MMM YYYY")
              : "-"}
            {/* {' - '}
            {item.agreementPeriod && item.agreementStartDate
              ? moment(item.agreementStartDate).add(item.agreementPeriod, 'M').format("DD, MMM YY")
              : item.moveOutDate && moment(item.moveOutDate).isValid()
                ? moment(item.moveOutDate).format("DD, MMM YY")
                : "N/A"} */}
          </span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Property",
          accessor: "roomNum",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Property",
        accessor: "roomNum",
      },
      // {
      //   Header: "Security",
      //   accessor: "security",
      // },
      {
        Header: "Rent",
        accessor: "rent",
      },
      {
        Header: isMovingOut === 'M' ? "Moving Out" : "Move-In",
        accessor: "moveInOutDate",
      },
      {
        Header: "Dues",
        accessor: "dues",
      },
      {
        Header: "",
        accessor: "action",
      },
    ];
  }, [isMobileView, isMovingOut]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);
  useEffect(() => {
    //setCurrentPage(pageIndex); // Update current page on state change
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            const rowData = apiData[rowIndex];
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                // onClick={() =>
                //   navigate(`/tenantdetails/${rowData.tenantId}`, {
                //     state: { data: rowData },
                //   })
                // }
                //style={{ cursor: "pointer" }}
                >
                  {row.cells.map((cell, cellIndex) => {
                    const isActionCell = cell.column.id === "action";
                    return (
                      <Td
                        {...cell.getCellProps()}
                      // onClick={(event) => {
                      //   // Prevent row click for action button
                      //   if (isActionCell) event.stopPropagation();
                      // }}
                      // onClick={["name", "rent", "roomNum", "moveInOutDate", "status"].includes(cell.column.id) ? () => goToDues ('Tenant Info', cell) : null}

                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Rent</strong>{" "}
                          {data[rowIndex].rent}
                        </li>
                        <li>
                          <strong>Agreement Duration</strong>{" "}
                          {data[rowIndex].moveInOutDate}
                        </li>

                        <li className="flex gap-2">
                          <strong>Status</strong>{" "}
                          {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Dues:</strong> {data[rowIndex].dues}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {/* {apiData?.length === 0 && <NotFoundModel />} */}
    </>
  );
};

const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
// const Tr = tw.tr`${(props) =>
//   props.hasdata === "true"
//     ? "border-b"
//     : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
  transition
`;

const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const IdUpload = tw.div`bg-green-100 text-green-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Personal = tw.div`bg-orange-100 text-orange-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Selfie = tw.div`bg-lime-100 text-lime-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const RentAgreement = tw.div`bg-teal-100 text-teal-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Verification = tw.div`bg-yellow-100 text-yellow-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const KycPending = tw.div`bg-blue-100 text-blue-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Unknown = tw.div`bg-zinc-100 text-zinc-500 font-bold text-xs grid place-items-center rounded-lg h-7 w-7 cursor-pointer`;
const Unverified = tw.div`bg-yellow-50 text-yellow-700 text-xs border-yellow-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Vaccines = tw.div`bg-blue-50 text-blue-700 text-xs border-blue-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Requested = tw.div`bg-lime-50 text-lime-700 text-xs border-lime-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Occupied = tw.div`bg-green-50 text-green-700 text-xs border-green-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Reserved = tw.div`bg-orange-50 text-orange-700 text-xs border-orange-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Linked = tw.div`bg-purple-50 text-purple-700 text-xs border-purple-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Moving = tw.div`bg-rose-50 text-rose-700 text-xs border-rose-100 border w-24 h-7 flex items-center justify-center rounded-lg`;
const Amount = tw.p`text-sm font-medium text-rose-700 bg-rose-100 px-3 py-1 rounded-full cursor-default hover:bg-rose-200 transition inline-flex`
const MoveOutData = tw.p`text-gray-600 text-sm bg-amber-100 px-3 py-1 rounded-md inline-flex`

export default Table;
